import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { PanelMenuModule } from 'primeng/panelmenu';
import { SidebarModule } from 'primeng/sidebar';

import { SideSigvMenuComponent } from './side-menu.component';

const PRIMENG_MODULES = [PanelMenuModule, SidebarModule, BreadcrumbModule];
@NgModule({
  declarations: [SideSigvMenuComponent],
  imports: [TranslateModule, ...PRIMENG_MODULES],
  exports: [SideSigvMenuComponent],
})
export class SideMenuModule {}
